import { Route, RouterProvider, Navigate, createHashRouter, createRoutesFromElements } from 'react-router-dom'

import { LayoutBase } from '../components/layout'
import { Loading, ErrorBoundary } from '../components/ui'

import PageIndex from './index'
import PageTrackingOrder from './tracking-order'
import PageTrackingSeller from './tracking-seller'
import PageTrackingServientrega from './tracking-servientrega'
import PageFaqs from './faqs'

const router = createHashRouter(
    createRoutesFromElements(
        <Route path="/" element={<LayoutBase />} errorElement={<ErrorBoundary />}>
            <Route path="/" element={<PageIndex />} key="index" />
            <Route path="/faqs" element={<PageFaqs />} key="faqs" />
            <Route
                path="/pedido/:id"
                element={<PageTrackingOrder />}
                errorElement={<ErrorBoundary />}
            />
            <Route 
                path="/consultora/:id"
                element={<PageTrackingSeller />} 
                errorElement={<ErrorBoundary />}
            />
            <Route
                path="/tracking/servientrega/:numeroGuia"
                element={<PageTrackingServientrega />}
                errorElement={<ErrorBoundary />}
            />
            <Route path="*" element={<Navigate to='/' replace />} />
        </Route>
    )
)

const Routes = () => {
    return (
        <RouterProvider router={router} fallbackElement={<Loading/>}/>
    )
}

export default Routes
